import { webappConfiguration } from '@talend/context';
import { pendo } from '@talend/ua';

export async function bootstrapUserAnalytics(): Promise<void | null> {
	const config = webappConfiguration.getCache();
	if (config.pendoEnabled) {
		try {
			return await pendo(config.pendoApiKey);
		} catch (e) {
			// TODO Log into Sentry
		}
	}
	return null;
}
